<template>
  <button
    :class="[style.tabPanel, active ? style.active : null]"
    :disabled="disabled"
    type="button"
    :aria-pressed="active"
  >
    <slot>
      {{ text }}
    </slot>
  </button>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./TabPanel.module.scss";

export default defineComponent({
  name: "TabPanel",
  props: {
    text: {
      type: String,
      default: ""
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      style
    };
  }
});
</script>
